
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CollectingData from "@/router/views/reporting/collectingData.vue";

/**
 * Reporting component
 */
export default {
  page: {
    title: "SettingsMenu",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, CollectingData},

};
</script>

<template>
  <Layout>
    <div class="px-3">
      <CollectingData/>
    </div>

  </Layout>
</template>
